import { safeLocalStorage } from './safeLocalStorage';
import { ProfileType } from './safeSessionStorage/schema';

export { ProfileType };

export interface ProfileSelection {
  profileId: string;
  profileType: ProfileType;
}

export const LAST_VIEWED_PROFILE_KEY = 'lastViewedProfile';

/**
 * Persist the last viewed profile to localStorage (survives logout / cross-tab)
 */
export const persistLastViewedProfile = (profile: ProfileSelection): void => {
  safeLocalStorage.setItem(LAST_VIEWED_PROFILE_KEY, profile);
};

/**
 * Get the last viewed profile from localStorage
 * Returns null if no profile was saved
 */
export const getLastViewedProfile = (): ProfileSelection | null => {
  return safeLocalStorage.getItem(LAST_VIEWED_PROFILE_KEY);
};

/**
 * Clear the last viewed profile
 */
export const clearLastViewedProfile = (): void => {
  safeLocalStorage.removeItem(LAST_VIEWED_PROFILE_KEY);
};
